export default __webpack_public_path__ + "static/media/fa-regular-400.dd9a1216.eot";